import { useRouter } from "next/router"
import { type PropsWithChildren } from "react"
import { AuthProvider } from "@/lib/blueprint-auth/client"
import { DASHBOARD_ROOT_URL } from "@/routes/dashboard"

export function CustomAuthProvider({ children }: PropsWithChildren) {
    const router = useRouter()

    return (
        <AuthProvider
            onLogoutSuccess={(defaultRedirect) => {
                if (router.pathname.startsWith(`/${DASHBOARD_ROOT_URL}`)) {
                    defaultRedirect()
                }
            }}
        >
            {children}
        </AuthProvider>
    )
}
